<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="900" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ !formData.id ? $t('global.menu.backoffice.createLabel') :
                    $t('global.menu.backoffice.editLabel', { country: formData.name }) }}
            </h3>
        </template>

        <template #default>
            <v-form ref="form">

                <v-row class="shop-info-container">
                    <!-- Linke Spalte: Basisinformationen -->
                    <v-col cols="12" md="6">

                        <!-- <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.name') }}</v-label>
                                <v-text-field variant="outlined" v-model="formData.name" density="compact"
                                    :hide-details="true"></v-text-field>
                            </v-col>
                        </v-row> -->
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.name-de') }}</v-label>
                                <v-text-field variant="outlined" v-model="nameDE" density="compact"
                                    :hide-details="true" :rules="nameDERules"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.name-en') }}</v-label>
                                <v-text-field variant="outlined" v-model="nameEN" density="compact"
                                    :hide-details="true" :rules="nameENRules"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">FrontendId</v-label>
                                <v-text-field variant="outlined" v-model="formData.frontendId" type="number" density="compact"
                                    :hide-details="true" :rules="frontendIdRules"></v-text-field>
                            </v-col>
                        </v-row>


                    </v-col>
                    <v-col cols="12" md="6">
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">Color (Hex Code)</v-label>
                                <v-text-field variant="outlined" v-model="formData.color" density="compact"
                                    :hide-details="true" :rules="colorRules">
                                    <template v-slot:append-inner>
                                        <v-menu :close-on-content-click="false">
                                            <template v-slot:activator="{ props }">
                                                <v-avatar size="x-small" class="mr-2 clickable border-md"
                                                    :color="formData.color" v-bind="props"></v-avatar>
                                            </template>
                                            <v-color-picker mode="hex" v-model="formData.color" hide-inputs></v-color-picker>
                                        </v-menu>

                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">Icon</v-label>
                                <v-text-field variant="outlined" v-model="formData.iconUrl" density="compact"
                                    :hide-details="true" :rules="iconRules"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4"> {{ $t('global.menu.backoffice.labelCategory') }} </v-label>
                                <v-select variant="outlined" :items="items" v-model="formData.labelCategory"
                                    item-title="name" return-object density="compact" :hide-details="true" :rules="categoryRules"></v-select>
                            </v-col>
                        </v-row>
                    </v-col>

                    <!-- {{ formData }} -->
                </v-row>
            </v-form>

        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="validate">{{ $t('global.form.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "CreateLabelDialog",
    components: {
    },


    methods: {
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import LabelCategories from '../LabelCategories.vue';


const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({ translations: { DE: { value: '' }, EN: { value: '' } } }) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
const form = ref(null)
const { proxy } = getCurrentInstance()
const props = defineProps({
    save: Function, // Define prop as a function
    items: Array
});

const nameDERules = [
    v => !!v || 'Name(Deutsch) is required',
    v => (v && v.length >= 3) || 'Name(Deutsch) must be at least 3 characters',
];
const nameENRules = [
    v => !!v || 'Name(English) is required',
    v => (v && v.length >= 3) || 'Name(English) must be at least 3 characters',
];

const colorRules = [
    v => !!v || 'Color (Hex Code) is required',
    v => /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(v) || 'Color must be valid Hex Code',
];

const iconRules = [
    v => !!v || 'Icon is required',
];

const frontendIdRules = [
    v => !!v || 'frontendId is required',
    v => (v && v.toString().length >= 1) || 'frontendId must be at least 1 digit.',
]

const categoryRules = [
    v => !!v || 'Label KAtegorie is required',
]

const validate = async () => {
    const { valid, errors } = await form.value.validate()
    if (!valid) {
        let errorMessages = [];
        Object.values(errors).forEach(fieldErrors => {
            if (fieldErrors.errorMessages.length) {
                errorMessages.push(...fieldErrors.errorMessages);
            }
        });
        errorMessages.forEach(msg => {
            if (msg.length) {
                proxy.$toast.error(msg, { theme: "colored" });
            }
        })
         
        return;
    }
    props.save();
}


watch(
    () => formData.value?.translations?.DE?.value, // Safe access using optional chaining
    (newValue) => {
        if (newValue !== undefined) {
            formData.value.name = newValue; // Update name
        }
    },
    { deep: true } // Optional: If translations can be updated dynamically
);
watch(formData, (newValue) => {
    if (!newValue) {
        formData.value = { translations: { DE: { value: '' }, EN: { value: '' } } };
    }
});
watch(dialogVisible, (newValue) => {
    if (!newValue) {
        formData.value = { translations: { DE: { value: '' }, EN: { value: '' } } };
    }
});

const nameDE = computed({
    get: () => formData.value.translations?.['DE']?.value || '', // Use optional chaining
    set: (val) => {
        if (!formData.value.translations) {
            formData.value.translations = {}; // Ensure translations object exists
        }
        if (!formData.value.translations['DE']) {
            formData.value.translations['DE'] = { value: '' }; // Ensure DE object exists
        }
        formData.value.translations['DE'].value = val;
    },
});

const nameEN = computed({
    get: () => formData.value.translations?.['EN']?.value || '',
    set: (val) => {
        if (!formData.value.translations) {
            formData.value.translations = {};
        }
        if (!formData.value.translations['EN']) {
            formData.value.translations['EN'] = { value: '' };
        }
        formData.value.translations['EN'].value = val;
    },
});

const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = { translations: { DE: { value: '' }, EN: { value: '' } } };
}
onMounted(() => {

});
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}
</style>
